import { render, staticRenderFns } from "./Kalender.vue?vue&type=template&id=31355b24&scoped=true&"
import script from "./Kalender.vue?vue&type=script&lang=js&"
export * from "./Kalender.vue?vue&type=script&lang=js&"
import style0 from "./Kalender.vue?vue&type=style&index=0&id=31355b24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31355b24",
  null
  
)

export default component.exports